export const handleMaxDecimalPlaces = (value: string, decimalPlaces: number) => {
  const parsedValue = parseFloat(value);
  if (!parsedValue) {
    return value;
  }
  return +parseFloat(value).toFixed(decimalPlaces);
};
